import { FunctionComponent } from "react";
import StackComponent from "../../../../components/stack";
import PeopleAltRoundedIcon from '@mui/icons-material/PeopleAltRounded';

interface MembrosStackComponentProps {
  objectWithValues: any[]
}

const CadastrosStackComponent: FunctionComponent<MembrosStackComponentProps> = ({ objectWithValues }) => {
  const membrosHoje = objectWithValues?.filter((el) => {
    const fmtDat = new Date(el?.inscricao)?.toLocaleString('pt-BR')?.split(',')[0]?.replaceAll('/', '-');
    const hoje = new Date(Date.now())?.toLocaleString('pt-BR')?.split(',')[0]?.replaceAll('/', '-');
    return fmtDat?.match(hoje)
  })

  return (<>
    <StackComponent
      icon={<PeopleAltRoundedIcon />}
      title="Cadastros"
      total={`${objectWithValues?.length}`}
      valueActual={`Novos ${membrosHoje?.length}`}
    />
  </>);
}

export default CadastrosStackComponent;
